import {useCallback} from 'react';
import {Box, Button, Center, Stack} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {ROUTES} from 'core';

const Error503SceneFC = () => {
  const {t} = useT();

  const handleRefresh = useCallback(() => {
    document.location = ROUTES.Chat.Root;
  }, []);

  return (
    <Center h={'100%'}>
      <Stack gap={0} alignItems={'center'}>
        <Box textAlign={'center'} fontSize={'32px'} fontWeight={900}>
          503
        </Box>

        <Box textAlign={'center'}>{t('labels.maintenance')}</Box>

        <Button mt={'16px'} w={'180px'} size={'lg'} variant={'solid'} onClick={handleRefresh}>
          {t('actions.refresh')}
        </Button>
      </Stack>
    </Center>
  );
};

export const Error503Scene = Error503SceneFC;
